import { environment } from "src/environments/environment";

export const ApiEndPoint = {
  getOtp: `${environment.url}getOtp`,
  addRole: `${environment.url}addRole`,
  signOut: `${environment.url}signOut`,
  addPlant: `${environment.url}addPlant`,
  eiRating: `${environment.url}eiRating`,
  shareApp: `${environment.url}shareApp`,
  addEIUser: `${environment.url}addEIUser`,
  urlToBlob: `${environment.url}urlToBlob`,
  verifyOtp: `${environment.url}verifyOtp`,
  googleLogin: `${environment.url}googleLogin`,
  addDefects: `${environment.url}addDefects`,
  deleteFile: `${environment.url}deleteFile`,
  getEIUsers: `${environment.url}getEIUsers`,
  updateUser: `${environment.url}updateUser`,
  uploadFile: `${environment.url}uploadFile`,
  addGuidance: `${environment.url}addGuidance`,
  closeAction: `${environment.url}closeAction`,
  getAllSites: `${environment.url}getAllSites`,
  getEIStepNo: `${environment.url}getEIStepNo`,
  rejectAsset: `${environment.url}rejectAsset`,
  updateAsset: `${environment.url}updateAsset`,
  updatePlant: `${environment.url}updatePlant`,
  uploadImage: `${environment.url}uploadImage`,
  getAllCache: `${environment.url}getAllCache`,
  getAFinding: `${environment.url}getAFinding`,
  addZoneType: `${environment.url}addZoneType`,
  addAdminRole: `${environment.url}addAdminRole`,
  approveAsset: `${environment.url}approveAsset`,
  closeFinding: `${environment.url}closeFinding`,
  deleteAction: `${environment.url}deleteAction`,
  deleteDefect: `${environment.url}deleteDefect`,
  deleteEIUser: `${environment.url}deleteEIUser`,
  getAdminRole: `${environment.url}getAdminRole`,
  getAllAssets: `${environment.url}getAllAssets`,
  getAssetList: `${environment.url}getAssetList`,
  getDashboard: `${environment.url}getDashboard`,
  getEICountry: `${environment.url}getEICountry`,
  noNewFinding: `${environment.url}noNewFinding`,
  registerUser: `${environment.url}registerUser`,
  updateEIUser: `${environment.url}updateEIUser`,
  getZoneTypes: `${environment.url}getZoneTypes`,
  addDraftAsset: `${environment.url}addDraftAsset`,
  approveAssets: `${environment.url}approveAssets`,
  deleteFinding: `${environment.url}deleteFinding`,
  getActivities: `${environment.url}getActivities`,
  getAdminRoles: `${environment.url}getAdminRoles`,
  getEILanguage: `${environment.url}getEILanguage`,
  getSingleUser: `${environment.url}getSingleUser`,
  registerAsset: `${environment.url}registerAsset`,
  createSession: `${environment.url}createSession`,
  getAllEiCache: `${environment.url}getAllEiCache`,
  getAllUsers: `${environment.url}getAllUsersBogPro`,
  addDraftAssets: `${environment.url}addDraftAssets`,
  addMMInventory: `${environment.url}addMMInventory`,
  addSiteFencing: `${environment.url}addSiteFencing`,
  addZoneFencing: `${environment.url}addZoneFencing`,
  changeUserRole: `${environment.url}changeUserRole`,
  deleteGuidance: `${environment.url}deleteGuidance`,
  deleteMaterial: `${environment.url}deleteMaterial`,
  getAllFindings: `${environment.url}getAllFindings`,
  getAllGuidance: `${environment.url}getAllGuidance`,
  getTranslation: `${environment.url}getTranslation`,
  reassignAction: `${environment.url}reassignAction`,
  updateSiteInfo: `${environment.url}updateSiteInfo`,
  registerAssets: `${environment.url}registerAssets`,
  addProductLine: `${environment.url}addProductLine`,
  deleteZoneType: `${environment.url}deleteZoneType`,
  updateZoneType: `${environment.url}updateZoneType`,
  getAllRegion: `${environment.bogUrl}getRegionBogPro`,
  getBogRegion: `${environment.bogUrl}getAllBogRegion`,
  updateChallenge: `${environment.url}updateChallenge`,
  assetDemolition: `${environment.url}assetDemolition`,
  downloadSapLogs: `${environment.url}downloadSapLogs`,
  getCheckInSites: `${environment.url}getCheckInSites`,
  getSiteSettings: `${environment.url}getSiteSettings`,
  updateAdminRole: `${environment.url}updateAdminRole`,
  syncApppDetails: `${environment.url}syncApppDetails`,
  getAUserActions: `${environment.url}getAUserActions`,
  getProductLines: `${environment.url}getProductLines`,
  cancelReportJob: `${environment.url}cancelReportJob`,
  deleteQrBogPro: `${environment.bogUrl}deleteQrBogPro`,
  getAllAssesment: `${environment.url}getAllAssessment`,
  getBMCreBogPro: `${environment.bogUrl}getBMCreBogPro`,
  addNoteToFinding: `${environment.url}addNoteToFinding`,
  deleteBucketFile: `${environment.url}deleteBucketFile`,
  getEIEnergyTypes: `${environment.url}getEIEnergyTypes`,
  getMaterialTypes: `${environment.url}getMaterialTypes`,
  sapConfiguration: `${environment.url}sapConfiguration`,
  getAllUsersCache: `${environment.url}getAllUsersCache`,
  sendNotification: `${environment.url}sendNotification`,
  toggleZoneStatus: `${environment.url}toggleZoneStatus`,
  updateEILanguage: `${environment.url}updateEILanguage`,
  updateSingleUser: `${environment.url}updateSingleUser`,
  updateSapKeyCode: `${environment.url}updateSapKeyCode`,
  getAUserFindings: `${environment.url}getAUserFindings`,
  addSecurityRoute: `${environment.url}addSecurityRoute`,
  createAnUser: `${environment.bogUrl}createAnUserBogPro`,
  getPlantById: `${environment.bogUrl}getPlantByIdBogPro`,
  getRandRData: `${environment.bogUrl}getRandRDataBogPro`,
  getSiteObservationCounts: `${environment.bogUrl}getSiteObservationCountsBogPro`,
  getBMBaseBogPro: `${environment.bogUrl}getBMBaseBogPro`,
  getBMRoadBogPro: `${environment.bogUrl}getBMRoadBogPro`,
  addEiMasterData: `${environment.url}addEiMasterData`,
  deleteProductLine: `${environment.url}deleteProductLine`,
  updateProductLine: `${environment.url}updateProductLine`,
  addMasterSubAsset: `${environment.url}addMasterSubAsset`,
  updateDraftAssets: `${environment.url}updateDraftAssets`,
  getAllBogProUsers: `${environment.url}getAllBogProUsers`,
  getCountProcedure: `${environment.url}getCountProcedure`,
  getWhoIsWho: `${environment.bogUrl}getWhosWhoDataBogPro`,
  addFindingToiCare: `${environment.url}addFindingToiCare`,
  addMapOcrProperty: `${environment.url}addMapOcrProperty`,
  assesmentCreation: `${environment.url}assesmentCreation`,
  assetDecommission: `${environment.url}assetDecommission`,
  assetRevertStatus: `${environment.url}assetRevertStatus`,
  deleteEIProcedure: `${environment.url}deleteEIProcedure`,
  deleteSiteFencing: `${environment.url}deleteSiteFencing`,
  eiProcedureReport: `${environment.url}eiProcedureReport`,
  getAllConnections: `${environment.url}getAllConnections`,
  getAllMasterAsset: `${environment.url}getAllMasterAsset`,
  getConnectionLogs: `${environment.url}getConnectionLogs`,
  getERPAssetsCount: `${environment.url}getERPAssetsCount`,
  getUserActiveJobs: `${environment.url}getUserActiveJobs`,
  removeDraftAssets: `${environment.url}removeDraftAssets`,
  updateMMInventory: `${environment.url}updateMMInventory`,
  configureSite: `${environment.bogUrl}configureSiteBogPro`,
  getUserDetail: `${environment.bogUrl}getUserDetailBogPro`,
  getReportingDate: `${environment.bogUrl}getReportingDate`,
  searchOpcoBogPro: `${environment.bogUrl}searchOpcoBogPro`,
  uploadEIUserData: `${environment.url}uploadEIUserByExcel`,
  getAllDataEiMaster: `${environment.url}getAllDataEiMaster`,
  postReportingDate: `${environment.bogUrl}getReportingDate`,
  getMaterialHazards: `${environment.url}getMaterialHazards`,
  getMMInventoryList: `${environment.url}getMMInventoryList`,
  getReportJobStatus: `${environment.url}getReportJobStatus`,
  cancelBulkEmailJob: `${environment.url}cancelBulkEmailJob`,
  getUserAssignRoles: `${environment.url}getUserAssignRoles`,
  updateEIUserChange: `${environment.url}updateEIUserChange`,
  getAllSubAssetList: `${environment.url}getAllSubAssetList`,
  addSiteSecurityPoi: `${environment.url}addSiteSecurityPoi`,
  getAssetMasterById: `${environment.url}getAssetMasterById`,
  validatePullSystem: `${environment.url}validatePullSystem`,
  getEISitesByCountry: `${environment.url}getSitesByCountry`,
  getAFindingActions: `${environment.url}getAFindingActions`,
  executeTriviaTutor: `${environment.url}executeTriviaTutor`,
  addMaterialControl: `${environment.url}addMaterialControl`,
  addAtSiblingLevel: `${environment.bogUrl}addAtSiblingLevel`,
  updateEiMasterData: `${environment.url}updateEiMasterData`,
  getHighLowLightScore: `${environment.bogUrl}getHighLowLight`,
  getUserCalendarLink: `${environment.url}getUserCalendarLink`,
  getSiteCalendarLink: `${environment.url}getSiteCalendarLink`,
  addGuidedInspection: `${environment.url}addGuidedInspection`,
  getAllNotifications: `${environment.url}getAllNotifications`,
  getEIUserListByRole: `${environment.url}getEIUserListByRole`,
  getGuidedInspection: `${environment.url}getGuidedInspection`,
  getLocationCategory: `${environment.url}getLocationCategory`,
  sendMailForEiReport: `${environment.url}sendMailForEiReport`,
  updateNotifications: `${environment.url}updateNotifications`,
  deleteEiMasterData: `${environment.url}deleteEiMasterData`,
  addSecurityLocation: `${environment.url}addSecurityLocation`,
  updateSecurityRoute: `${environment.url}updateSecurityRoute`,
  deleteSecurityRoute: `${environment.url}deleteSecurityRoute`,
  getAllActiveGru: `${environment.bogUrl}getAllActiveGruBogPro`,
  updateAdminRoleInBog: `${environment.bogUrl}updateRoleBogPro`,
  getBMFitnessBogPro: `${environment.bogUrl}getBMFitnessBogPro`,
  syncIcareLocations: `${environment.bogUrl}syncIcareLocations`,
  ingestTriviaDocument: `${environment.url}ingestTriviaDocument`,
  deleteTriviaDocument: `${environment.url}deleteTriviaDocument`,
  getAssetMappingCache: `${environment.url}getAssetMappingCache`,
  connectionActivation: `${environment.url}connectionActivation`,
  deactivateDraftAsset: `${environment.url}deactivateDraftAsset`,
  updateMasterSubAsset: `${environment.url}updateMasterSubAsset`,
  deleteMasterSubAsset: `${environment.url}deleteMasterSubAsset`,
  getDashboardCalendar: `${environment.url}getDashboardCalendar`,
  getDefaultSAPPushUrl: `${environment.url}getDefaultSAPPushUrl`,
  getGlobalMMInventory: `${environment.url}getGlobalMMInventory`,
  mm_ControlSheetToPdf: `${environment.url}mm_ControlSheetToPdf`,
  syncExcelToExpertApp: `${environment.url}syncExcelToExpertApp`,
  approveFitnessScores: `${environment.url}approveFitnessScores`,
  getAllDepartment: `${environment.bogUrl}getAllDepartmentBogPro`,
  getIcareLocation: `${environment.bogUrl}getIcareLocationBogPro`,
  getSingleUserBogPro: `${environment.bogUrl}getSingleUserBogPro`,
  getPlantByOpcoId: `${environment.bogUrl}getPlantByOpcoIdBogPro`,
  getRapidTourData: `${environment.bogUrl}getRapidTourDataBogPro`,
  actionClosureBogPro: `${environment.bogUrl}actionClosureBogPro`,
  testIcareConnection: `${environment.bogUrl}testIcareConnection`,
  uploadImageOnSamePath: `${environment.url}uploadImageOnSamePath`,
  updateSiteSecurityPoi: `${environment.url}updateSiteSecurityPoi`,
  deleteSiteSecurityPoi: `${environment.url}deleteSiteSecurityPoi`,
  deactivateDraftAssets: `${environment.url}deactivateDraftAssets`,
  sendEmailToPerfEditor: `${environment.url}sendEmailToPerfEditor`,
  getMasterSubAssetById: `${environment.url}getMasterSubAssetById`,
  getGadEmployees: `${environment.bogUrl}getAllGadEmployeesBogPro`,
  removeDemolishedAsset: `${environment.url}removeDemolishedAsset`,
  assetsSendForApproval: `${environment.url}assetsSendForApproval`,
  getEnergyIsolationProcedure: `${environment.url}getEIProcedures`,
  checkExistingGuidance: `${environment.url}checkExistingGuidance`,
  revokeScoreSubmission: `${environment.url}revokeScoreSubmission`,
  rejectScoreSubmission: `${environment.url}rejectScoreSubmission`,
  deleteMaterialControl: `${environment.url}deleteMaterialControl`,
  getAllDepartments: `${environment.bogUrl}getAllDepartmentsBogPro`,
  getAllRegionsOnly: `${environment.bogUrl}getAllRegionsOnlyBogPro`,
  getAllUserProfile: `${environment.bogUrl}getAllUserProfileBogPro`,
  getCustomerConfig: `${environment.bogUrl}getCustomerConfigBogPro`,
  getTODOActionsBogPro: `${environment.bogUrl}getTODOActionsBogPro`,
  reAssignActionBogPro: `${environment.bogUrl}reAssignActionBogPro`,
  saveOrUpdateQrBogPro: `${environment.bogUrl}saveOrUpdateQrBogPro`,
  getHighLowLightScores: `${environment.bogUrl}getHighLowLightData`,
  getSendBulkEmailstatus: `${environment.url}getBulkEmailJobStatus`,
  getBMScorecardBogPro: `${environment.bogUrl}getBMScorecardBogPro`,
  syncIcareDepartments: `${environment.bogUrl}syncIcareDepartments`,
  getFlameReviewAssets: `${environment.bogUrl}getFlameReviewAssets`,
  getAllUsersForACountry: `${environment.url}getAllUsersForACountry`,
  addTransportsExplosive: `${environment.url}addTransportsExplosive`,
  removeGuidedInspection: `${environment.url}removeGuidedInspection`,
  changeAssessmentStatus: `${environment.url}changeAssessmentStatus`,
  getAllGuidedInspection: `${environment.url}getAllGuidedInspection`,
  getAllSapConfiguration: `${environment.url}getAllSapConfiguration`,
  getGuidanceDetailsById: `${environment.url}getGuidanceDetailsById`,
  getIsolationDeviceType: `${environment.url}getIsolationDeviceType`,
  getUserActiveEmailJobs: `${environment.url}getUserActiveEmailJobs`,
  saveMMControlInventory: `${environment.url}saveMMControlInventory`,
  updateAssessmentStatus: `${environment.url}updateAssessmentStatus`,
  updateGuidedInspection: `${environment.url}updateGuidedInspection`,
  approvePredictAUScores: `${environment.url}approvePredictAUScores`,
  updateSecurityLocation: `${environment.url}updateSecurityLocation`,
  deleteSecurityLocation: `${environment.url}deleteSecurityLocation`,
  updateLevelInfoBogPro: `${environment.bogUrl}updateLevelInfoBogPro`,
  getAllNearestSites: `${environment.bogUrl}getAllNearestSitesBogPro`,
  getAllBogRegionGroups: `${environment.bogUrl}getAllBogRegionGroups`,
  getOpcoByCountryId: `${environment.bogUrl}getOpcoByCountryIdBogPro`,
  getRegionFromIcare: `${environment.bogUrl}getRegionFromIcareBogPro`,
  downloadReportsBogPro: `${environment.bogUrl}downloadReportsBogPro`,
  getBMEngagementBogPro: `${environment.bogUrl}getBMEngagementBogPro`,
  getFlameAssetGameData: `${environment.bogUrl}getFlameAssetGameData`,
  addSiteSecurityCategory: `${environment.url}addSiteSecurityCategory`,
  getTransportsExplosives: `${environment.url}getTransportsExplosives`,
  bulkApprovalEIProcedure: `${environment.url}bulkApprovalEIProcedure`,
  sendPerfEmailReportMail: `${environment.url}sendPerfEmailReportMail`,
  testConnectionForAWSSQS: `${environment.url}testConnectionForAWSSQS`,
  submitScoresForApproval: `${environment.url}submitScoresForApproval`,
  addHazardMasterMaterial: `${environment.url}addHazardMasterMaterial`,
  getChildDataByIdBogPro: `${environment.bogUrl}getChildDataByIdBogPro`,
  getBogSingleUserBogPro: `${environment.bogUrl}getBogSingleUserBogPro`,
  getIncidentCiLogBogPro: `${environment.bogUrl}getIncidentCiLogBogPro`,
  getLocalCurrencyBogPro: `${environment.bogUrl}getLocalCurrencyBogPro`,
  sendReportToMailBogPro: `${environment.bogUrl}sendReportToMailBogPro`,
  updatePlantInformation: `${environment.bogUrl}updatePlantInformation`,
  updateSingleUserBogPro: `${environment.bogUrl}updateSingleUserBogPro`,
  getTenantHierarchyData: `${environment.bogUrl}getTenantHierarchyData`,
  updateEnergyIsolationProcedure: `${environment.url}updateEIProcedure`,
  getHSEDashboardMetrics: `${environment.bogUrl}getHSEDashboardMetrics`,  getBMEnvironmentBogPro: `${environment.bogUrl}getBMEnvironmentBogPro`,
  verifyFlameReviewAsset: `${environment.bogUrl}verifyFlameReviewAsset`,
  createTriviaTutorSession: `${environment.url}createTriviaTutorSession`,
  updateAssetConfiguration: `${environment.url}updateAssetConfiguration`,
  addMasterSubAssetAsDraft: `${environment.url}addMasterSubAssetAsDraft`,
  addSubAssetToMasterAsset: `${environment.url}addSubAssetToMasterAsset`,
  assetResubmitForApproval: `${environment.url}assetResubmitForApproval`,
  assetsPendingForApproval: `${environment.url}assetsPendingForApproval`,
  deleteMMControlInventory: `${environment.url}deleteMMControlInventory`,
  generatePerformanceGraph: `${environment.url}generatePerformanceGraph`,
  getBusinessSegmentBySite: `${environment.url}getBusinessSegmentBySite`,
  updateEISelectedLanguage: `${environment.url}updateEISelectedLanguage`,
  transferLevelDataBogPro: `${environment.bogUrl}transferLevelDataBogPro`,
  configureSiteFencing: `${environment.bogUrl}configureSiteFencingBogPro`,
  getCountryByRegionId: `${environment.bogUrl}getCountryByRegionIdBogPro`,
  getKeylessonsPpesBogPro: `${environment.bogUrl}getKeylessonsPpesBogPro`,
  getKeylessonsPuesBogPro: `${environment.bogUrl}getKeylessonsPuesBogPro`,
  getQRFromSiteByIdBogPro: `${environment.bogUrl}getQRFromSiteByIdBogPro`,
  getReportTemplateBogPro: `${environment.bogUrl}getReportTemplateBogPro`,
  getSegmentsMasterBogPro: `${environment.bogUrl}getSegmentsMasterBogPro`,
  recallCriticalIncidents: `${environment.bogUrl}recallCriticalIncidents`,
  deleteTransportsExplosive: `${environment.url}deleteTransportsExplosive`,
  updateTransportsExplosive: `${environment.url}updateTransportsExplosive`,
  getAllAssetMasterDataList: `${environment.url}getAllAssetMasterDataList`,
  createNewVersionProcedure: `${environment.url}createNewVersionProcedure`,
  deleteZoneFencingAndNames: `${environment.url}deleteZoneFencingAndNames`,
  getLocationTrackingStatus: `${environment.url}getLocationTrackingStatus`,
  getMMControlInventoryList: `${environment.url}getMMControlInventoryList`,
  mapSapAssetsConfiguration: `${environment.url}mapSapAssetsConfiguration`,
  addMaterialMasterOCRLabel: `${environment.url}addMaterialMasterOCRLabel`,
  configureSiteZoneName: `${environment.bogUrl}configureSiteZoneNameBogPro`,
  getAllUsersShieldUser: `${environment.bogUrl}getAllUsersShieldUserBogPro`,
  createHighLowLightBogPro: `${environment.bogUrl}createHighLowLightBogPro`,
  getFollowUpActionsBogPro: `${environment.bogUrl}getFollowUpActionsBogPro`,
  saveReportTemplateBogPro: `${environment.bogUrl}saveReportTemplateBogPro`,
  getHseUnitRecognition: `${environment.bogUrl}getHseUnitRecognitionBogPro`,
  updateSiteSecurityCategory: `${environment.url}updateSiteSecurityCategory`,
  deleteSiteSecurityCategory: `${environment.url}deleteSiteSecurityCategory`,
  bogProImplementationReport: `${environment.url}bogProImplementationReport`,
  securityMappingReport: `${environment.url}securityMappingReport`,
  generateReportAndSendEmail: `${environment.url}generateReportAndSendEmail`,
  getFilterRegionCountrySite: `${environment.url}getFilterRegionCountrySite`,
  getGuidedInspectionDetails: `${environment.url}getGuidedInspectionDetails`,
  getMMInventoryListBySiteId: `${environment.url}getMMInventoryListBySiteId`,
  getPredictAUScoreByPeriods: `${environment.url}getPredictAUScoreByPeriods`,
  updateMaterialMasterHazard: `${environment.url}updateMaterialMasterHazard`,
  deleteMaterialMasterHazard: `${environment.url}deleteMaterialMasterHazard`,
  getLocationHirerchyConfig: `${environment.bogUrl}getLocationHirerchyConfig`,
  getAllLocationsByLevel: `${environment.bogUrl}getAllLocationsByLevelBogPro`,
  getOrganisationDetails: `${environment.bogUrl}getOrganisationDetailsBogPro`,
  addSinglePolishedIncident: `${environment.bogUrl}addSinglePolishedIncident`,
  getHseUserQuestionsBogPro: `${environment.bogUrl}getHseUserQuestionsBogPro`,
  updateSubAssetInMasterAsset: `${environment.url}updateSubAssetInMasterAsset`,
  addOCRNotMappedPropertyData: `${environment.url}addOCRNotMappedPropertyData`,
  MM_safetySheetToExtractData: `${environment.url}mm_SafetySheetToExtractData`,
  getAiPlatformScoreByPeriods: `${environment.url}getAiPlatformScoreByPeriods`,
  updateMaterialMasterControl: `${environment.url}updateMaterialMasterControl`,
  getAllUnitsWithinLevels: `${environment.bogUrl}getAllUnitsWithinLevelsBogPro`,
  postEnergyIsolationProcedure: `${environment.url}addEnergyIsolationProcedure`,
  getBMIncidentHistoryBogPro: `${environment.bogUrl}getBMIncidentHistoryBogPro`,
  getFlameReviewWithAllGames: `${environment.bogUrl}getFlameReviewWithAllGames`,
  addMaterialMasterBannedWaste: `${environment.url}addMaterialMasterBannedWaste`,
  updateMaterialMasterOCRLabel: `${environment.url}updateMaterialMasterOCRLabel`,
  deleteMaterialMasterOCRLabel: `${environment.url}deleteMaterialMasterOCRLabel`,
  getCountryFlagKeynames: `${environment.bogUrl}getPerformanceCountryFlagsBogPro`,
  getAllPlantsWithinLevels: `${environment.bogUrl}getAllPlantsWithinLevelsBogPro`,
  addCriticalIncidentPolished: `${environment.bogUrl}addCriticalIncidentPolished`,
  getCriticalIncidentPolished: `${environment.bogUrl}getCriticalIncidentPolished`,
  getHousekeepingStatsForSite: `${environment.bogUrl}getHousekeepingStatsForSite`,
  getHousekeepingStatsForUnit: `${environment.bogUrl}getHousekeepingStatsForUnit`,
  getHseCountryRecognition: `${environment.bogUrl}getHseCountryRecognitionBogPro`,
  removeSubAssetFromMasterAsset: `${environment.url}removeSubAssetFromMasterAsset`,
  addMaterialMasterRegistration: `${environment.url}addMaterialMasterRegistration`,
  addLocationMasterLevelBogPro: `${environment.bogUrl}addLocationMasterLevelBogPro`,
  updateLocationHirerchyConfig: `${environment.bogUrl}updateLocationHirerchyConfig`,
  saveLocationHierarchyData: `${environment.bogUrl}saveLocationHierarchyDataBogPro`,
  updateOrganisationDetails: `${environment.bogUrl}updateOrganisationDetailsBogPro`,
  syncIcareSecondaryWorkgroups: `${environment.bogUrl}syncIcareSecondaryWorkgroups`,
  getPerformanceReportSendConfig: `${environment.url}getPerformanceReportSendConfig`,
  getAssessmentsForCountriesSite: `${environment.url}getAssessmentsForCountriesSite`,
  updateRiskLevelRequestByExpert: `${environment.url}updateRiskLevelRequestByExpert`,
  getSystemActivePerformanceJobs: `${environment.url}getSystemActivePerformanceJobs`,
  getLoggedInUserEIProcedureList: `${environment.url}getLoggedInUserEIProcedureList`,
  submitPerformanceTabCompletion: `${environment.url}submitPerformanceTabCompletion`,
  testConnectionForAmazonCognito: `${environment.url}testConnectionForAmazonCognito`,
  updateMaterialAssessmentStatus: `${environment.url}updateMaterialAssessmentStatus`,
  updateOCRNotMappedPropertyData: `${environment.url}updateOCRNotMappedPropertyData`,
  materialRequestUpdateToEditors: `${environment.url}materialRequestUpdateToEditors`,
  getHousekeepingStatsForGRU: `${environment.bogUrl}getHousekeepingStatsForGRUBogPro`,
  getPlantsByUnitIdFromIcare: `${environment.bogUrl}getPlantsByUnitIdFromIcareBogPro`,
  getUnitByOpcoNameFromIcare: `${environment.bogUrl}getUnitByOpcoNameFromIcareBogPro`,
  updateWeeklyDataAnswersBogPro: `${environment.bogUrl}updateWeeklyDataAnswersBogPro`,
  addFindingForMaterialManagement: `${environment.url}addFindingForMaterialManagement`,
  getAiPlatformUnitScoreByPeriods: `${environment.url}getAiPlatformUnitScoreByPeriods`,
  updateMaterialMasterBannedWaste: `${environment.url}updateMaterialMasterBannedWaste`,
  deleteMaterialMasterBannedWaste: `${environment.url}deleteMaterialMasterBannedWaste`,
  getOpcoByCountryIdFromIcare: `${environment.bogUrl}getOpcoByCountryIdFromIcareBogPro`,
  getHousekeepingStatsForCountry: `${environment.bogUrl}getHousekeepingStatsForCountry`,
  getUserEmailsFromEmployeesList: `${environment.bogUrl}getUserEmailsFromEmployeesList`,
  getHseExcellenceUserDataBogPro: `${environment.bogUrl}getHseExcellenceUserDataBogPro`,
  assessmentAssetDetectionCreation: `${environment.url}assessmentAssetDetectionCreation`,
  connectionSetupForAssetInventory: `${environment.url}connectionSetupForAssetInventory`,
  fetchCriticalIncidentPerformance: `${environment.url}fetchCriticalIncidentPerformance`,
  getConnectionAssetsConfiguration: `${environment.url}getConnectionAssetsConfiguration`,
  uploadPMCodeConfigurationInExcel: `${environment.url}uploadPMCodeConfigurationInExcel`,
  updateMaterialMasterRegistration: `${environment.url}updateMaterialMasterRegistration`,
  deleteMaterialMasterRegistration: `${environment.url}deleteMaterialMasterRegistration`,
  getAllPerformanceLocationBogPro: `${environment.bogUrl}getAllPerformanceLocationBogPro`,
  saveAllPerformanceReportsBogPro: `${environment.bogUrl}saveAllPerformanceReportsBogPro`,
  getCountryByRegionIdFromIcare: `${environment.bogUrl}getCountryByRegionIdFromIcareBogPro`,
  getMultipleUnitHighLowDataBogPro: `${environment.bogUrl}getMultipleUnitHighLowDataBogPro`,
  getActiveRegionsCountryGroupBogPro: `${environment.url}getActiveRegionsCountryGroupBogPro`,
  getHousekeepingCommentsForSite: `${environment.bogUrl}getHousekeepingCommentsForSiteBogPro`,
  sendBulkPerformanceEmailReportMails: `${environment.url}sendBulkPerformanceEmailReportMails`,
  findPersonFromIcarePersonMaster: `${environment.bogUrl}findPersonFromIcarePersonMasterBogPro`,
  generatePerformancePdfReportBogPro: `${environment.bogUrl}generatePerformancePdfReportBogPro`,
  connectionSetupForCreateNotification: `${environment.url}connectionSetupForCreateNotification`,
  getMultipleCountryHighLowDataBogPro: `${environment.bogUrl}getMultipleCountryHighLowDataBogPro`,
  addPerformanceUserSubscriptionsBogPro: `${environment.url}addPerformanceUserSubscriptionsBogPro`,
  getPerformanceUserSubscriptionsBogPro: `${environment.url}getPerformanceUserSubscriptionsBogPro`,
  sendMailForBogProImplementationReport: `${environment.url}sendMailForBogProImplementationReport`,
  testConnectionCreateNotificationOnSAP: `${environment.url}testConnectionCreateNotificationOnSAP`,
  getAllOpcoFromRegionCollectionBogPro: `${environment.bogUrl}getAllOpcoFromRegionCollectionBogPro`,
  getCountryFromRegionCollectionBogPro: `${environment.bogUrl}getCountryFromRegionCollectionBogPro`,
  fetchPerformanceHighLightsAndLowLights: `${environment.url}fetchPerformanceHighLightsAndLowLights`,
  getAllUniqueAssetTypeFromSAPAssetMaster: `${environment.url}getAllUniqueAssetTypeFromSAPAssetMaster`,
  getAllPerformanceLocationBogProFiltered: `${environment.bogUrl}getAllPerformanceLocationBogProFiltered`,
  generateMMControlSheetIntroductionByGemini: `${environment.url}generateMMControlSheetIntroductionByGemini`,
  getPlantInfoByIcarePlantNameFromRegion: `${environment.bogUrl}getPlantInfoByIcarePlantNameFromRegionBogPro`,
  getOpcoByCountryFromRegionCollectionBogPro: `${environment.bogUrl}getOpcoByCountryFromRegionCollectionBogPro`,
};
